import React from 'react'

/** Secao Administracao: os controles da organizacao. */
export function SecaoAdministracaoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        d="M4 6.5h8.5M17.5 6.5H20M4 12h2.5M11.5 12H20M4 17.5h6.5M15.5 17.5H20"
        stroke="#fff"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
      <circle cx="15" cy="6.5" r="2.4" stroke="#fff" strokeWidth="1.6" />
      <circle cx="9" cy="12" r="2.4" stroke="#fff" strokeWidth="1.6" />
      <circle cx="13" cy="17.5" r="2.4" stroke="#fff" strokeWidth="1.6" />
    </svg>
  )
}
